// extracted by mini-css-extract-plugin
module.exports = {"productImage":"_1Zbtx","productBadge":"_3BR2R","badge":"_27jOh","defaultImage":"_2UNHp"};